<!--
  ~ Developed for G.J. Gardner Homes by Softeq Development Corporation
  ~ http://www.softeq.com
  -->

<ng-content select="gh-ext-navigation-item[align=start]"></ng-content>
<div class="m-gap"></div>
<ng-content select="gh-ext-navigation-item[align=end]"></ng-content>
<div *ngIf="hasOptions" class="m-option-divider"></div>
